const UrlHelpers = require('components/shared/url_helpers');
const Adyen = require('components/adyen_tokenization');
const APIRequest = require('components/api_request.js');

const saveCreditCard = (creditCardData, billingAddressData) => {
  const creditCardParams = {
    adyen_token: Adyen.tokenizeCard({
      number: creditCardData.cardNumber,
      cvc: creditCardData.cvv,
      holderName: creditCardData.cardholderName,
      expiryMonth: creditCardData.expirationMonth,
      expiryYear: creditCardData.expirationYear,
    }),
    billing_address: {
      street_address: billingAddressData.streetAddress,
      extended_address: billingAddressData.extendedAddress,
      locality: billingAddressData.locality,
      region: billingAddressData.region,
      postal_code: billingAddressData.postalCode,
      country_code: billingAddressData.countryCode,
    },
  };

  if (creditCardData.id) {
    return APIRequest.V3.put(
      UrlHelpers.myCreditCardPath(creditCardData.id),
      creditCardParams,
    );
  }

  return APIRequest.V3.post(
    UrlHelpers.myCreditCardsCreatePath(),
    creditCardParams,
  );
};

module.exports = { saveCreditCard };



// WEBPACK FOOTER //
// ./javascripts/components/credit_cards/save_credit_card.js